export default defineNuxtPlugin((nuxtApp) => {
  const { locale } = nuxtApp.$i18n as { locale: Ref<string> };

  useHead({
    htmlAttrs: {
      lang: locale,
    },
  });
});
